import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { LayoutService } from '../services/layout.service';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-customizer',
  templateUrl: './customizer.component.html',
  styleUrls: ['./customizer.component.scss'],
})
export class CustomizerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('customizer', { static: false }) customizer: ElementRef;

  options = {
    direction: 'ltr',
    bgColor: 'black',
    transparentColor: '',
    bgImage: 'assets/img/sidebar-bg/03.jpg',
    bgImageDisplay: true,
    compactMenu: false,
    sidebarSize: 'sidebar-md',
    layout: 'Light',
  };
  size = 'sidebar-md';
  isOpen = false;
  public config: any = {};
  layoutSub: Subscription;
  isBgImageDisplay = true;
  selectedBgColor = 'black';
  selectedBgImage = 'assets/img/sidebar-bg/03.jpg';
  selectedTLBgColor = '';
  selectedTLBgImage = '';
  @Output() directionEvent = new EventEmitter<Record<string, any>>();

  constructor(
    private _renderer: Renderer2,
    private _layoutService: LayoutService,
    private _configService: ConfigService,
  ) {
    this.layoutSub = this._layoutService.customizerChangeEmitted$.subscribe(
      (options) => {
        if (options) {
          if (options.bgColor) {
            this.selectedBgColor = options.bgColor;
            this.selectedBgImage = options.bgImage;
          }
        }
      },
    );
  }

  ngOnInit(): void {
    this.config = this._configService.templateConf;
    // this.isOpen = !this.config.layout.customizer.hidden;

    if (this.config.layout.sidebar.size) {
      this.options.sidebarSize = this.config.layout.sidebar.size;
      this.size = this.config.layout.sidebar.size;
    }
  }

  ngAfterViewInit(): void {
    setTimeout((): void => {
      if (this.config.layout.dir) {
        this.options.direction = this.config.layout.dir;
      }

      if (this.config.layout.variant) {
        this.options.layout = this.config.layout.variant;
      }

      if (this.config.layout.sidebar.collapsed != undefined) {
        this.options.compactMenu = this.config.layout.sidebar.collapsed;
      }

      if (
        this.config.layout.sidebar.backgroundColor &&
        this.config.layout.sidebar.backgroundColor != ''
      ) {
        this.options.bgColor = this.config.layout.sidebar.backgroundColor;
        this.selectedBgColor = this.config.layout.sidebar.backgroundColor;
      } else {
        this.options.bgColor = 'black';
        this.selectedBgColor = 'black';
      }

      if (this.config.layout.sidebar.backgroundImage != undefined) {
        this.options.bgImageDisplay =
          this.config.layout.sidebar.backgroundImage;
        this.isBgImageDisplay = this.config.layout.sidebar.backgroundImage;
      }

      if (this.config.layout.sidebar.backgroundImageURL) {
        this.options.bgImage = this.config.layout.sidebar.backgroundImageURL;
        this.selectedBgImage = this.config.layout.sidebar.backgroundImageURL;
      }

      if (this.options.layout === 'Transparent') {
        this.options.bgColor = 'black';
        this.selectedBgColor = 'black';
        this.options.bgImageDisplay = false;
        this.selectedTLBgColor = '';
        this.selectedBgImage = '';
        this.options.bgImage = '';
        this.isBgImageDisplay = false;

        if (this.config.layout.sidebar.backgroundColor) {
          if (this.config.layout.sidebar.backgroundColor === 'bg-glass-1') {
            this.selectedTLBgImage = 'assets/img/gallery/bg-glass-1.jpg';
            this.options.transparentColor = 'bg-glass-1';
          } else if (
            this.config.layout.sidebar.backgroundColor === 'bg-glass-2'
          ) {
            this.selectedTLBgImage = 'assets/img/gallery/bg-glass-2.jpg';
            this.options.transparentColor = 'bg-glass-2';
          } else if (
            this.config.layout.sidebar.backgroundColor === 'bg-glass-3'
          ) {
            this.selectedTLBgImage = 'assets/img/gallery/bg-glass-3.jpg';
            this.options.transparentColor = 'bg-glass-3';
          } else if (
            this.config.layout.sidebar.backgroundColor === 'bg-glass-4'
          ) {
            this.selectedTLBgImage = 'assets/img/gallery/bg-glass-4.jpg';
            this.options.transparentColor = 'bg-glass-4';
          } else {
            this.options.transparentColor =
              this.config.layout.sidebar.backgroundColor;
            this.selectedTLBgColor = this.config.layout.sidebar.backgroundColor;
          }
        } else {
          this.options.bgColor = 'black';
          this.selectedBgColor = 'black';
          this.options.bgImageDisplay = false;
          this.selectedBgColor = '';
          this.selectedTLBgColor = '';
          this.selectedTLBgImage = 'assets/img/gallery/bg-glass-1.jpg';
          this.options.transparentColor = 'bg-glass-1';
        }
      }
    }, 0);
  }
  ngOnDestroy(): void {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

  sendOptions(): void {
    this.directionEvent.emit(this.options);
    this._layoutService.emitChange(this.options);
  }

  bgImageDisplay(e): void {
    if (e.target.checked) {
      this.options.bgImageDisplay = true;
      this.isBgImageDisplay = true;
    } else {
      this.options.bgImageDisplay = false;
      this.isBgImageDisplay = false;
    }

    //emit event to FUll Layout
    this._layoutService.emitCustomizerChange(this.options);
  }

  toggleCompactMenu(e): void {
    if (e.target.checked) {
      this.options.compactMenu = true;
    } else {
      this.options.compactMenu = false;
    }

    //emit event to FUll Layout
    this._layoutService.emitCustomizerChange(this.options);
  }

  changeSidebarWidth(value): void {
    this.options.sidebarSize = value;
    this.size = value;
    //emit event to FUll Layout
    this._layoutService.emitCustomizerChange(this.options);
  }

  onLightLayout(): void {
    this.options.layout = 'Light';
    this.options.bgColor = 'man-of-steel';
    this.selectedBgColor = 'man-of-steel';

    if (this.isBgImageDisplay) {
      this.options.bgImageDisplay = true;
    }

    //emit event to FUll Layout
    this._layoutService.emitCustomizerChange(this.options);
  }

  onDarkLayout(): void {
    this.options.layout = 'Dark';
    this.options.bgColor = 'black';
    this.selectedBgColor = 'black';

    if (this.isBgImageDisplay) {
      this.options.bgImageDisplay = true;
    }

    //emit event to FUll Layout
    this._layoutService.emitCustomizerChange(this.options);
  }

  onTransparentLayout(): void {
    this.options.layout = 'Transparent';
    this.options.bgColor = 'black';
    this.selectedBgColor = 'black';
    this.options.bgImageDisplay = false;
    this.selectedBgColor = '';
    this.selectedTLBgColor = '';
    this.selectedTLBgImage = 'assets/img/gallery/bg-glass-1.jpg';
    this.options.transparentColor = 'bg-glass-1';

    //emit event to FUll Layout
    this._layoutService.emitCustomizerChange(this.options);
  }

  toggleCustomizer(): void {
    if (this.isOpen) {
      this._renderer.removeClass(this.customizer.nativeElement, 'open');
      this.isOpen = false;
    } else {
      this._renderer.addClass(this.customizer.nativeElement, 'open');
      this.isOpen = true;
    }
  }

  closeCustomizer(): void {
    this._renderer.removeClass(this.customizer.nativeElement, 'open');
    this.isOpen = false;
  }

  changeSidebarBgColor(color): void {
    this.selectedBgColor = color;
    this.selectedTLBgColor = '';
    this.options.bgColor = color;

    if (this.isBgImageDisplay) {
      this.options.bgImageDisplay = true;
    }

    //emit event to FUll Layout
    this._layoutService.emitCustomizerChange(this.options);
  }

  changeSidebarBgImage(url): void {
    this.selectedBgImage = url;
    this.selectedTLBgImage = '';

    //emit event to FUll Layout
    this.options.bgImage = url;

    if (this.isBgImageDisplay) {
      this.options.bgImageDisplay = true;
    }

    //emit event to FUll Layout
    this._layoutService.emitCustomizerChange(this.options);
  }

  changeSidebarTLBgColor(color): void {
    this.selectedBgColor = '';
    this.selectedTLBgColor = color;
    this.selectedTLBgImage = '';
    this.options.transparentColor = color;
    this.options.bgImageDisplay = false;

    //emit event to FUll Layout

    this._layoutService.emitCustomizerChange(this.options);
  }

  changeSidebarTLBgImage(url, color): void {
    this.selectedTLBgColor = '';
    this.selectedTLBgImage = url;
    this.options.transparentColor = color;
    this.options.bgImageDisplay = false;

    //emit event to FUll Layout

    this._layoutService.emitCustomizerChange(this.options);
  }
}
